export default function responsiveValues (width) {
    let object
    //Mobiles
    if (width < 720) {
        object = {
            //INITIAL SETS
            objPosX: 0,
            objPosY: 6,
            objPosZ: -20,
            objRotY: -Math.PI/8,
            //Entry Animation
            entryObjPosY: 0,

            //Components Part
            ComponentsRotY: -Math.PI,
            ComponentsPosX: 0,
            ComponentPosZ: -25,
            CameraPosY: -18,
        }
    }
    //Tablets
    else if (width >= 720 && width < 1024) {
        object = {
            objPosX: 1.4,
            objPosY: -10,
            objPosZ: -3.5,
            objRotY: -Math.PI/15,

            entryObjPosY: 0,

            ComponentsRotY: -Math.PI,
            ComponentsPosX: 0,
            ComponentPosZ: -20,
            CameraPosY: -18,
        }
    }
    // Desktops
    else if (width >= 1024){
        object = {
            objPosX: 2,
            objPosY: -10,
            objPosZ: -3.5,
            objRotY: -Math.PI/15,

            entryObjPosY: 0,

            ComponentsRotY:-Math.PI/2,
            ComponentsPosX: 0,
            ComponentPosZ: -13,
            CameraPosY: -10,
        }
    }

    return object
}